<template>
<div class="modal"
     :class="{ 'is-active': isShown }"
>
    <div class="modal-background" @click="hideModal"></div>

    <div class="modal-card">

        <header class="modal-card-head">
            <p class="modal-card-title">
                {{ trans.select_users_title }}
            </p>
            <button class="delete" aria-label="close"
                    @click="hideModal"
            ></button>
        </header>

        <section class="modal-card-body" @scroll="onScroll">
            <div class="content">
                <user-list
                    v-bind="$props"
                    :allow-select="true"
                >
                </user-list>
            </div>

            <loading-block
                v-if="isLoading"
                :message="trans.loader_message"
            >
            </loading-block>
        </section>

        <footer class="modal-card-foot">
            <button class="button is-info"
                    @click="hideModal"
            >
                {{ trans.select_users_button }}
            </button>
        </footer>

    </div>
</div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import userListMixin from "../../../mixins/userListMixin";
    import UserList from "./UserList";
    import LoadingBlock from "../../utils/LoadingBlock";
    import {axiosForm} from "../../../mixins/axiosFormMixin";

    export default {
        components: {LoadingBlock, UserList},
        mixins: [userListMixin, axiosForm],
        data() {
            return {
                form: {
                    start: 0,
                },
                portalUsers: null,
            };
        },
        methods: {
            ...mapActions('userManagement', {
                hideModal: 'hideUserSelectModal',
                setPortalUsers: 'setPortalUsers',
            }),

            /**
             * Обработчик скролла модального окна
             * @param scrollTop
             * @param clientHeight
             * @param scrollHeight
             */
            onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
                let isLoadRequired = scrollTop + clientHeight >= scrollHeight - 500;

                if (isLoadRequired && !this.isLoading && this.form.start) {
                    this.submit();
                }
            },

            /**
             * Обработчик ответа сервера
             * @param response
             */
            postResultHandler(response) {
                this.form.start = response.data.next;
                this.portalUsers = Object.assign({}, this.portalUsers, response.data.users);
                this.setPortalUsers(this.portalUsers);
            },
        },
        computed: {
            ...mapState('userManagement', {
                isShown: 'isUserSelectModalShown',
            })
        },
        watch: {
            isShown() {
                if (this.isShown && !this.portalUsers) {
                    this.submit();
                }
            }
        }
    }
</script>

<styles lang="scss" scoped>
    .modal-card-foot {
        justify-content: center;
    }
</styles>
